import angular from 'angular';

import loginContainer from './containers/login.container';
import logoutContainer from './containers/logout.container';
import rememberContainer from './containers/remember.container';
import resetPasswordContainer from './containers/resetPassword.container';
import login from './components/login/login.component';
import remember from './components/remember/remember.component';
import resetPassword from './components/resetPassword/resetPassword.component';
import routeProviderConfig from './configs/routeProvider.config';
import routesAuthorization from './eventsSubscribers/routesAuthorization';

import './assets/scss/loginBox.scss';

const userModule = angular.module('user', [])
.component('loginContainer', loginContainer)
.component('logoutContainer', logoutContainer)
.component('rememberContainer', rememberContainer)
.component('resetPasswordContainer', resetPasswordContainer)
.component('login', login)
.component('remember', remember)
.component('resetPassword', resetPassword)
.config(routeProviderConfig)
.run(routesAuthorization);


export default userModule.name;
